import { atom } from 'jotai';
/**
 * 网络连接状态的类型定义
 */
interface ConnectivityState {
  isOnline: boolean;
  isGoogleAccessible: boolean | null;
  isLoading: boolean;
  lastChecked: Date | null;
  error: string | null;
}

export const ConnectivityStateAtom = atom<ConnectivityState>({
  isOnline: true,
  isGoogleAccessible: null,
  isLoading: false,
  lastChecked: null,
  error: null,
});
